import { render, staticRenderFns } from "./orderInvoice.vue?vue&type=template&id=fc9945ba&scoped=true"
import script from "./orderInvoice.vue?vue&type=script&lang=js"
export * from "./orderInvoice.vue?vue&type=script&lang=js"
import style0 from "./orderInvoice.vue?vue&type=style&index=0&id=fc9945ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9945ba",
  null
  
)

export default component.exports